import { all } from 'redux-saga/effects';

import appSaga from './app.saga';
import meSaga from './me.saga';
import booksSaga from './books.saga';
import packagesSaga from './packages.saga';
import projectsSaga from './projects.saga';
import photosSaga from './photos.saga';
import usersSaga from './users.saga';
import chaptersSaga from './chapters.saga';
import versionsSaga from './versions.saga';
import ratingsSaga from './ratings.saga';
import questionnairesSaga from './questionnaires.saga';
import interviewsSaga from './interviews.saga';
import pricesSaga from './prices.saga';
import promptsSaga from './prompts.saga';
import upgradeRequests from './upgradeRequests.saga';

export default function* rootSaga() {
  yield all([
    ...appSaga,
    ...meSaga,
    ...booksSaga,
    ...packagesSaga,
    ...projectsSaga,
    ...photosSaga,
    ...usersSaga,
    ...chaptersSaga,
    ...versionsSaga,
    ...ratingsSaga,
    ...questionnairesSaga,
    ...interviewsSaga,
    ...pricesSaga,
    ...promptsSaga,
    ...upgradeRequests,
  ]);
}
